module.exports = __webpack_public_path__ + "fonts/Poppins-LightItalic.0613c488.ttf";